import { useTranslation } from 'react-i18next';
import { ReactComponent as TruckIcon } from '../../../../../assets/svg/load-card/truck.svg';
import { IWinnerDetails } from '../../ILoadCardBody';
import { getFormattedDescription } from '../../utils/load-card-body-utils';
import { getCodeAndDescriptionFormatted } from '../../../../../../utils/string-utils';
import LoadsConstants from '../../../../../../pages/business/loads/constants';

export default function LoadCardBodyWinner(props: Readonly<IWinnerDetails>) {
    const { show, code, description } = props;

    const { t } = useTranslation();

    const winnerLabel = getCodeAndDescriptionFormatted(
        code,
        description,
        LoadsConstants.NO_INFO_TEXT,
    );

    return (
        <div
            className="card-loads-body__carrier-info"
            style={{
                visibility: show ? 'visible' : 'hidden',
            }}
            data-testid="card-loads-body__carrier-info"
        >
            <span className="card-loads-body__destination-icon">
                <TruckIcon />
            </span>
            <span className="card-loads-body__routeDetailLabel">
                {t('Transportadora')}
            </span>
            <span className="card-loads-body__routeDetailLabel-data">
                {getFormattedDescription(winnerLabel)}
            </span>
        </div>
    );
}
